import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../../../../../components/form/FormInput';
import { getValidationObject } from '../../../../../../constants/regexPatterns';
import { selectInsured } from '../../../../../../redux/modules/insured';
import InsuredInfoPanel from '../InsuredInfoPanel';

const ParentInsuredInfo = ({ onClose }) => {
  const { parent = {} } = useSelector(selectInsured);

  const useFormMethods = useForm({
    defaultValues: {
      parent: {
        insuredCompanyName: parent.insuredCompanyName,
        externalId: parent.externalId
      }
    }
  });

  const { handleSubmit } = useFormMethods;

  const onSubmit = data => {
    console.log(data);
  };

  const formStack = [
    { name: 'parent.insuredCompanyName', placeholder: 'Parent Company Name' },
    { name: 'parent.externalId', placeholder: 'Parent ID', validation: getValidationObject('alphaNumericAndCharacters') }
  ];

  return (
    <InsuredInfoPanel title="parent insured" onClose={onClose} onSave={onSubmit}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack flexBasis="100%" pb="30px" spacing={12}>
          {formStack.map(input => (
            <FormInput
              isDisabled
              inputName={input.name}
              key={input.name}
              labelName={input.placeholder}
              placeholder={input.placeholder}
              useFormMethods={useFormMethods}
              validationRules={input?.validation}
            />
          ))}
        </VStack>
      </form>
    </InsuredInfoPanel>
  );
};

ParentInsuredInfo.propTypes = { onClose: PropTypes.func.isRequired };

export default ParentInsuredInfo;
